import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import styles from "./SelectionsLoadingSkeleton.module.scss";
import LoadingSelection from "./components/LoadingSelection";

const SelectionsLoadingSkeleton = ({ selections, shuffle }) => {
  const { ppConfig } = useSelector((state) => state.filter);

  const handleSelectionLoadingSkeletonClassName = () => {
    if (!shuffle && Object.keys(ppConfig).length > 0) {
      return "selectionsLoadingSkeleton--loading";
    }
    if (shuffle) {
      return "selectionsLoadingSkeleton--shuffle-loading";
    }
    return null;
  };

  // If selections is undefined or empty we hardcode the number to display otherwise we map over selections
  return (
    // if ppConfig has already been loaded and selections are updated we add shimmer to the skeleton
    <div
      data-testid="selections-loading-skeleton"
      className={`${styles.selectionsLoadingSkeleton} ${
        styles[`${handleSelectionLoadingSkeletonClassName()}`]
      }`}
    >
      {selections?.length ? (
        selections.map((selection) => (
          <LoadingSelection
            key={`selection-${selection.mappedEventId}-${selection.selection.id}-${selection.selection.marketId}`}
          />
        ))
      ) : (
        // TODO: May need tweaking to consider different screen sizes
        <>
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
          <LoadingSelection />
        </>
      )}
    </div>
  );
};

SelectionsLoadingSkeleton.propTypes = {
  selections: PropTypes.arrayOf(
    PropTypes.shape({
      mappedEventId: PropTypes.string,
      selection: PropTypes.shape({
        id: PropTypes.string,
        marketId: PropTypes.string,
      }),
    })
  ),
  shuffle: PropTypes.bool,
};

export default SelectionsLoadingSkeleton;
